import {Record} from 'immutable';

/** Department admin page profile selector option. */
export default class FilterWordsProfile extends Record({
  id: null,
  name: null,
}) {
  constructor(object = {}) {
    super(
      Object.assign({}, object, {
        id: object.filterWordProfileId, // translate for departments page
      })
    );
  }
}
